import api from '../api';

export const chartsService = {
  getTotalVtrHora: async (
    filters?: SimpleDateFilterProps
  ): Promise<ReturnTotalVtrHora[]> =>
    await api.post('/rotas/graficos/total-vtr-hora', filters),

  getVtrEmpenhadasByHour: async (
    filters?: DateFilterProps
  ): Promise<ReturnTotalVtrHora[]> =>
    await api.post('/rotas/graficos/total-vtr-ocupadas-hora', filters),

  getVtrEmpenhadas: async (
    filters?: DateFilterProps
  ): Promise<ReturnVtrEnpenhadas[]> =>
    await api.post('/rotas/graficos/viaturas-empenhadas', filters),
};
